import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { useMediaQuery } from "@mui/material";

export default function DeleteModal({ open, handleClose, type }) {
  const { t } = useTranslation();

  const isMobile = useMediaQuery("(max-width:1400px)");
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        PaperProps={{
          sx: !isMobile
            ? { width: "30%", padding: "20px " }
            : { width: "90%", height: "80%", margin: "5px 0", padding: "5px " },
        }}
        disableBackdropClick
        disableEnforceFocus
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>

        <DialogTitle mb={1} align="center" >
          <Typography variant="title1" sx={{ fontSize: "38px" }} >
            {type === "not_selected"
              ? t("select_organization")
              : t("fill_organization")}
          </Typography>
        </DialogTitle>
        {type === "not_completed" && (
          <DialogContent sx={{ padding: "15px 10px" }}>
            <DialogContentText mb={2} align="center" id="control">
              {t("not_completed_message")}
            </DialogContentText>
          </DialogContent>
        )}
      </Dialog>
    </div>
  );
}
